import { createRemoteReducer, RemoteReducer } from "types/Remote"
import { TagGroupStructure } from "types/Template"

export const labelReducer: RemoteReducer<TagGroupStructure[]> =
  createRemoteReducer("label")
